import Divider from 'components/divider/Divider';
import { useTranslation } from 'react-i18next';
import './Footer.scss';
import { Link } from 'react-router';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer'>
      <div className='footer-top'>
        {/* Company Description */}
        <div className='footer-section'>
          <img src='/carboncap.png' alt='Company Logo' className='footer-logo' />
          <p>{t('footer.companyDescription')}</p>
        </div>

        {/* Quick Menu */}
        <div className='footer-section'>
          <h3>{t('footer.quickMenu.title')}</h3>
          <ul>
            <li>
              <Link to='/' className='footer-link'>
                {t('footer.quickMenu.home')}
              </Link>
            </li>
            <li>
              <Link to='/about' className='footer-link'>
                {t('footer.quickMenu.about')}
              </Link>
            </li>
            <li>
              <Link to='/blog' className='footer-link'>
                {t('footer.quickMenu.resource')}
              </Link>
            </li>
            <li>
              <Link to='/impact' className='footer-link'>
                {t('footer.quickMenu.impact')}
              </Link>
            </li>
            <li>
              <Link to='/contact' className='footer-link'>
                {t('footer.quickMenu.contact')}
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className='footer-section'>
          <h3>{t('footer.legal.title')}</h3>
          <ul>
            <li>
              <Link to='/Terms' className='footer-link'>
                {t('footer.legal.terms')}
              </Link>
            </li>
            <li>
              <Link to='/' className='footer-link'>
                {t('footer.legal.privacy')}
              </Link>
            </li>
            <li>
              <Link to='/' className='footer-link'>
                {t('footer.legal.environmental')}
              </Link>
            </li>
            <li>
              <Link to='/' className='footer-link'>
                {t('footer.legal.faqs')}
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className='footer-section'>
          <h3>{t('footer.contact.title')}</h3>
          <ul>
            <li>
              <a href='mailto:Info@carboncap.pk' className='footer-link'>
                {t('contact.mail')}
              </a>
            </li>
            <li>
              <a href='tel:+92-3045159411' className='footer-link'>
                {t('contact.phone')}
              </a>
            </li>
            <li>{t('footer.contact.address')}</li>
          </ul>
        </div>

        {/* Social */}
        <div className='footer-section'>
          <h3>{t('footer.social.title')}</h3>
          <ul className='footer-links'>
            <li>
              <a
                target='__blank'
                href='https://www.linkedin.com/company/carboncap-pk/'
                className='footer-link'
                aria-label='LinkedIn'
              >
                <img src='/icons/linkedin.png' alt='LinkedIn' className='footer-icon' />
              </a>
            </li>
            {/* <li>
              <a
                href='https://www.instagram.com/mfsyspvt?igsh=MTI2cG14bHpzaGhuMA=='
                className='footer-link'
                aria-label='Instagram'
              >
                <img src='/icons/instagram.png' alt='Instagram' className='footer-icon' />
              </a>
            </li> */}
            <li>
              <a
                target='__blank'
                href='https://www.youtube.com/@carboncapofficial33'
                className='footer-link'
                aria-label='YouTube'
              >
                <img src='/icons/youtube.png' alt='YouTube' className='footer-icon' />
              </a>
            </li>
            {/* <li>
              <a href='https://www.facebook.com/mfsystems' className='footer-link' aria-label='Facebook'>
                <img src='/icons/facebook.png' alt='Facebook' className='footer-icon' />
              </a>
            </li> */}
          </ul>
        </div>
      </div>

      <div className='footer-bottom'>
        <p>{t('footer.copyright', { year: currentYear })}</p>
        <p>{t('footer.releaseDate')}</p>
      </div>
    </footer>
  );
};

export default Footer;
